import { Link, useLocation } from "react-router-dom";
import { scrollToSection } from "../../lib/scroll";

// Crawlable anchor link: real href (/#section) with smooth scroll when already on the homepage.
export default function SectionLink({ id, children, className, onNavigate, ...anchorProps }) {
  const { pathname } = useLocation();
  const onClick = (e) => {
    onNavigate?.();
    if (pathname !== "/") return;
    e.preventDefault();
    scrollToSection(id);
  };
  return (
    <Link to={`/#${id}`} onClick={onClick} className={className} {...anchorProps}>
      {children}
    </Link>
  );
}
